import { Thankyou } from "./thankyou";

class Pix
{
    constructor() {
        new Thankyou;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Pix;
});